import React, { useState } from "react";
import axios from "axios";
import copy from "copy-to-clipboard";
import ShareButton from "../Buttons/ShareButton";
import PlaylistVideo from "../Layout/PlaylistVideo";
import PremierePlaylistVideo from "../Layout/PremierePlaylistVideo";
import { validateExpirationDate } from "../../utils/handlePremiereDates";

const Playlist = ({
  playlist,
  playlistName,
  company,
  url,
  color,
  setFile,
  cat,
}) => {
  let [state, setState] = React.useState({
    company,
    cat,
    playlist: [],
  });
  const mountedRef = React.useRef(null);

  const [copied, setCopied] = useState(false);
  const [embedCopy, setEmbedCopy] = useState(false);

  // Empty array used to only run once.
  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    if (playlist) {
      setState({ ...state, playlist });
    }
    if (mountedRef.current) {
      axios.get(`${url}/playlist/${state.company}/${state.cat}`).then((res) => {
        if (res.data.response.success) {
          setState({ ...state, playlist: res.data.response.payload });
        } else {
          setState({ cat: "Error, Playlist Does Not Exist" });
        }
      });
    }
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps*/

  const parseTitle = (str) => {
    if (str) {
      let arr = str.split(" ");
      let response = [];

      arr.forEach((s) => {
        response.push(
          `${s.substring(0, 1).toUpperCase()}${s.substring(1).toLowerCase()}`
        );
      });

      return response.join(" ");
    } else return "";
  };

  // Here we are editing the url by replacing "playlist" with the info needed to point to our embed playlist url
  let embedPlaylistURL = window.location.href.replace(
    "/playlist/",
    "/embed/playlist/"
  );

  const embedPlaylist = () => {
    let embed = `
    <iframe
      src="${embedPlaylistURL}&embedID=${playlistName}"
      allowtransparency="true"
      frameborder="0"
      width="720rem"
      height="720rem"
      sandbox="allow-same-origin allow-forms allow-scripts"
      scrolling="auto"
      allowfullscreen
      style="border:none;border-radius:4px;"
      id="${playlistName}"
      onload="AdjustIframeHeightOnLoad('${playlistName}')"
    >
    </iframe>`;
    copy(embed);
    setEmbedCopy(true);
  };

  const getUrlAndCopy = () => {
    copy(embedPlaylistURL);
    setCopied(true);
  };

  var videos = state.playlist.map((item, i) => {
    if (validateExpirationDate(item?.premiereDate)) {
      return (
        <PremierePlaylistVideo
          item={item}
          key={item._id}
          index={i}
          id={item._id}
          filename={item.metadata.filename}
          description={item.metadata.description} 
        />
      )
    }
    else {
      return (
        <PlaylistVideo
          item={item}
          key={item._id}
          index={i}
          id={item._id}
          filename={item.metadata.filename}
          description={item.metadata.description}
          onClick={() => {
            setFile(item, state.playlist);
          }}
        />
      );
    }
   
  });

  const shareButtonProps = {
    buttonText: "SHARE PLAYLIST",
    color,
    copied,
    onCopyUrlClick: getUrlAndCopy,
    embedCopy,
    onEmbedVideoClick: embedPlaylist,
    copyUrlToolTip: "Copy Playlist Url",
    copyUrlToolTipPlacement: "bottom",
    embedToolTip: "Embed Playlist",
    embedToolTipPlacement: "bottom",
  };

  return (
    <>
      <div className="custom-container mt-3" ref={mountedRef}>
        <div className="social flex-row flex-half">
          <p className="home-section-header">{parseTitle(state.cat)}</p>
          <div className="ml-4 mt-2">
            <ShareButton {...shareButtonProps} />
          </div>
        </div>
        <div className="flex-row">
          <div className=" plst">{videos}</div>
        </div>
      </div>
    </>
  );
};

export default Playlist;
